import styles from "./FormStepper.module.scss"

type Props = {
  stepCount: number
  currentStep: number
}

export function FormStepper({ stepCount, currentStep }: Props) {
  return (
    <ol
      className={styles.stepper}
      aria-label={`Step ${currentStep + 1} of ${stepCount}`}
    >
      {Array.from({ length: stepCount }, (_, i) => (
        <li
          key={i}
          className={`${styles.step} ${
            i === currentStep
              ? styles.stepCurrent
              : i < currentStep
                ? styles.stepDone
                : styles.stepFuture
          }`}
          aria-current={i === currentStep ? "step" : undefined}
        />
      ))}
    </ol>
  )
}
